import { enableProdMode, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { SentryIntegrationService } from './app/services/sentry-integration.service';

if (environment.production) {
  enableProdMode();
}

if (!isDevMode()) {
  console.log('Production mode enabled');
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (environment.production) {
      const sentry = appRef.injector.get(SentryIntegrationService);
      void sentry.init();
    }
  })
  .catch((error) => console.error('Angular bootstrap failed', error));
